export const STORE_TYPE = 'ONBOARDING-INFO';